// 用户管理接口请求

import fetch from '../fetch';

import {
  // 潜客列表
  POSTENTIAL_LIST_NEW,
  SUPPORT_GET_SOURCE,
  // 潜客信息
  POTEN_INFO_OLD,
  POTEN_CONSUME_OLD,
} from '../url';

/**
 * 潜客列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getPostentialListNew(data) {
  return fetch({
    url: POSTENTIAL_LIST_NEW,
    method: 'POST',
    data: data
  });
};

/**
 * 获取会员来源列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function supportGetSource(data) {
  return fetch({
    url: SUPPORT_GET_SOURCE,
    method: 'GET',
    params: data
  });
};

// 查询潜客信息详情
function getPotenInfo(data) {
  return fetch({
    url: POTEN_INFO_OLD,
    method: 'get',
    params: data,
    isNoMsg: true
  });
}

// 查询潜客消费信息
function getPotenConsumeList(data) {
  return fetch({
    url: POTEN_CONSUME_OLD,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

const potentialMember = {
  // 潜客列表
  getPostentialListNew,
  supportGetSource,
  // 潜客信息
  getPotenInfo,
  // 潜客消费信息
  getPotenConsumeList,
};

export { potentialMember };
